import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable()
export class Interceptor401Service implements HttpInterceptor {

    constructor(@Inject(DOCUMENT) private document: Document) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                if ((error.status === 200 && error.url && error.url.includes('/cas/login')) || error.status === 401 || error.status === 403) {
                    this.document.location.href = `${environment.casUrl}/cas/login?service=${environment.casService}%2Flogin%2Fcas`;
                }
                return throwError(error);
            })
        );
    }
}